jQuery(function ($) { // wait for document ready
    var headerHeight = $('.page-header').outerHeight();
    var adminBarHeight = 0;
    if ($('#wpadminbar').length) {
        headerHeight += $('#wpadminbar').outerHeight();
        adminBarHeight += $('#wpadminbar').outerHeight();
    }
    var controller = new ScrollMagic.Controller({});
    var scenes = [];
    var doit;
    window.onresize = function(){
        clearTimeout(doit);
        doit = setTimeout(scrollSetup, 100);
    };
    scrollSetup();
    var curSize = '';
    function scrollSetup(force = false) {
        var windowWidth = $(window).width();
        var newSize = 'desktop';
        if (windowWidth <= 767) {
            newSize = 'mobile';
        }
        if (curSize == newSize && !force)
            return true;

        curSize = newSize;
        resetScrollMagic();
        var cookieVal = read_cookie('notice-dismissed');
        if (curSize == 'mobile') {

        }
        else if (curSize == 'desktop') {
            var slides;
            if ($('.wills-lpas-page').length) {
                if (cookieVal != 'dismissed') {
                    scenes.push(new ScrollMagic.Scene({triggerElement: "#slide2"})
                            // trigger animation by adding a css class
                            .setClassToggle($('.cta-floating')[0], "visible")
                        .addTo(controller));
                }
                else {
                    delete_cookie('notice-dismissed');
                }
            }
            if ($('.wills-page').length) {

                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide2',
                    offset: -1 * (headerHeight),
                    triggerHook: 'onEnter',
                    duration: '185%'
                })
                    .setClassToggle($('#slide2')[0], "active")
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide3',
                    offset: -1 * (headerHeight),
                    triggerHook: 'onLeave',
                    duration: '225%'
                })
                    .setClassToggle($('#slide3')[0], "active")
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide2',
                        duration: "175%",
                        offset: -1 * headerHeight
                    })
                        .setPin('#slide2', {pushFollowers: false})
                        // .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                        .addTo(controller)
                );
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide3',
                        duration: "100%",
                        offset: -1 * headerHeight
                    })
                        .setPin('#slide3', {pushFollowers: true})
                        // .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                        .addTo(controller)
                );
                slides = ['slide4','slide5','slide6','slide7','slide8'];
                $.each(slides,function(k,v) {
                    if (v == 'slide8') {
                        scenes.push(new ScrollMagic.Scene({
                            triggerHook: 'onLeave',
                            duration: "250%",
                            triggerElement: "#"+v,
                            offset: -1 * headerHeight
                        })
                            // trigger animation by adding a css class
                            .setClassToggle($('#'+v)[0], "active")
                            // .addIndicators() // add indicators (requires plugin)
                            .addTo(controller));
                    }
                    else if (k > 0) {
                        var previous = slides[k - 1];
                        scenes.push(new ScrollMagic.Scene({
                            triggerHook: 'onLeave',
                            duration: "83.5%",
                            triggerElement: "#"+v,
                            offset: -1 * headerHeight
                        })
                            // trigger animation by adding a css class
                            .setClassToggle($('#'+v)[0], "active")
                            // .addIndicators() // add indicators (requires plugin)
                            .addTo(controller));
                    }
                    else {
                        scenes.push(new ScrollMagic.Scene({
                            triggerHook: 'onEnter',
                            duration: "183.5%",
                            triggerElement: "#"+v,
                            offset: -1 * headerHeight
                        })
                            // trigger animation by adding a css class
                            .setClassToggle($('#'+v)[0], "active")
                            // .addIndicators() // add indicators (requires plugin)
                            .addTo(controller));
                    }
                    if (v == 'slide8') {
                        scenes.push(
                            new ScrollMagic.Scene({
                                triggerHook: 'onLeave',
                                triggerElement: '#'+v,
                                duration: "100%",
                                offset: -1 * headerHeight
                            })
                                .setPin('#'+v, {pushFollowers: true})
                                // .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                                .addTo(controller)
                        );
                    }
                    else {
                        scenes.push(
                            new ScrollMagic.Scene({
                                triggerHook: 'onLeave',
                                triggerElement: '#'+v,
                                duration: "300%",
                                offset: -1 * headerHeight
                            })
                                .setPin('#'+v, {pushFollowers: false})
                                // .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                                .addTo(controller)
                        );
                    }
                });
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide9a',
                        duration: "10%",
                        offset: -1 * headerHeight
                    })
                        .setPin('#slide9a', {pushFollowers: true})
                        // .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                        .addTo(controller)
                );
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide12',
                        duration: "50%",
                        offset: -1 * headerHeight
                    })
                        .setPin('#slide12', {pushFollowers: true})
                        // .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                        .addTo(controller)
                );
            }
            if ($('.lpas-page').length) {

                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide2',
                        duration: "210%",
                        offset: -1 * headerHeight
                    })
                        .setPin('#slide2', {pushFollowers: false})
                        // .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                        .addTo(controller)
                );
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onEnter',
                        triggerElement: '#slide2',
                        duration: "180%",
                        offset: -1 * headerHeight
                    })
                        .setClassToggle($('#slide2')[0], "active")
                        // .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                        .addTo(controller)
                );
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide3',
                        duration: "150%",
                        offset: -1 * headerHeight
                    })
                        .setPin('#slide3', {pushFollowers: false})
                        // .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                        .addTo(controller)
                );
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide3',
                        duration: "100%",
                        offset: -1 * headerHeight
                    })
                        .setClassToggle($('#slide3')[0], "active")
                        // .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                        .addTo(controller)
                );
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide3a',
                        duration: "50%",
                        offset: -1 * headerHeight
                    })
                        .setPin('#slide3a', {pushFollowers: true})
                        // .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                        .addTo(controller)
                );
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide3a',
                        duration: "150%",
                        offset: -1 * headerHeight
                    })
                        .setClassToggle($('#slide3a')[0], "active")
                        // .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                        .addTo(controller)
                );

                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide4',
                    offset: -1 * (headerHeight),
                    triggerHook: 0,
                    duration: 0
                })
                    .setClassToggle("#slide4", "active") // add class toggle
                    .addTo(controller));
                slides = ['slide4','slide5','slide6','slide7','slide8'];
                $.each(slides,function(k,v) {
                    scenes.push(
                        new ScrollMagic.Scene({
                            triggerHook: 'onLeave',
                            triggerElement: '#'+v,
                            duration: "75%",
                            offset: -1 * headerHeight
                        })
                            .setPin('#'+v, {pushFollowers: true})
                            // .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                            .addTo(controller)
                    );
                });
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide9',
                        duration: "50%",
                        offset: -1 * headerHeight
                    })
                        .setPin('#slide9', {pushFollowers: true})
                        // .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                        .addTo(controller)
                );
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide10',
                        duration: "100%",
                        offset: -1 * headerHeight
                    })
                        .setPin('#slide10', {pushFollowers: true})
                        // .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                        .addTo(controller)
                );
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide12',
                        duration: "100%",
                        offset: -1 * headerHeight
                    })
                        .setPin('#slide12', {pushFollowers: true})
                        // .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                        .addTo(controller)
                );
            }
        }
    }

    // Reset all scenes and controller
    function resetScrollMagic() {
        if (controller)
            controller.destroy('reset');
        controller = null;
        $.each(scenes,function(k,scene) {
            if (scenes[k])
            scenes[k].destroy('reset');
                scenes[k] = null;
        });
        controller = new ScrollMagic.Controller({});
    }
    if ($('.wills-lpas-page').length) {
        $(document).on('click','[data-action="load-inline"]',function(e) {
            e.preventDefault();
            var $this = $(this);
            var $target = $($this.data('target'));
            var urlPath = $this.attr('href');
            $target.animate({opacity:0},300,function() {
                $.ajax(urlPath,{
                    success: function(data) {
                        var html = $(data).find($this.data('target')).html();
                        $target.html(html);
                        loadIcons(true);
                        scrollSetup(true);
                        $target.animate({opacity:1},500);
                        document.title = $(data).filter('title').text();

                        $('html, body').animate({
                            scrollTop: $target.offset().top - headerHeight
                        }, 500, function() {
                            // Callback after animation
                            // Must change focus!
                            $target.focus();
                            if ($target.is(":focus")) { // Checking if the target was focused
                                return false;
                            } else {
                                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                                $target.focus(); // Set focus again
                            }
                        });
                        var pageTitle = document.title;
                        document.title = pageTitle;
                        window.history.pushState({"html":html,"pageTitle":pageTitle,"targetElement":$this.data('target')},pageTitle, urlPath);
                    }
                });
            });
        });
    }

    window.onpopstate = function(e){
        if(e.state){
            $(e.state.targetElement).html(e.state.html);
            document.title = e.state.pageTitle;
        }
        else
        {
            $('[data-action="load-inline"]').each(function() {
                $($(this).data('target')).html('');
            });
        }
    };
});